import React, { useEffect, useState } from "react";
import { storyAssets } from "../../constants/assets";
import { TrackingEvents } from "../../../../Utilities/analytics";
import WebSnowfall from "../WebSnowfall";
import WebLottiePlayer from "../WebLottiePlayer";
import ChatBubble from "../../../../components/ChatBubble/ChatBubble";
import WebShadowButton from "../WebShadowButton";
import { useNavigate } from "react-router-dom";

interface ClosingConversationItem {
  id?: number;
  content?: string;
  audio?: string;
  characterImage?: string;
  characterFontColor?: string;
}

interface WebClosingConvoScreenProps {
  bgImage?: string;
  conversations: ClosingConversationItem[];
  onTrackEvent?: (event: string, props?: Record<string, unknown>) => void;
  contentBaseUrl?: string;
}

const WebClosingConvoScreen: React.FC<WebClosingConvoScreenProps> = ({
  bgImage,
  conversations,
  onTrackEvent,
  contentBaseUrl,
}) => {
  const navigate = useNavigate();
  const [conversationIndex, setConversationIndex] = useState(0);

  useEffect(() => {
    if (conversationIndex < conversations.length - 1) {
      const timer = setTimeout(() => {
        setConversationIndex((prev) => prev + 1);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [conversationIndex, conversations.length]);

  const current = conversations[conversationIndex];

  return (
    <div className="web-break-closing-root">
      <div
        className="web-break-closing-bg"
        style={{ backgroundImage: bgImage ? `url(${bgImage})` : undefined }}
      />
      <WebSnowfall maxSize={2} />

      <header className="web-break-closing-header">
        <button
          type="button"
          className="web-break-header-btn"
          onClick={() => {
            onTrackEvent?.(TrackingEvents.navigate_to_journey_back);
            navigate("/web/appJourneyPage");
          }}
        >
          <WebLottiePlayer
            source={storyAssets.lottie.journeyIcon}
            className="web-break-header-icon"
            autoPlay={false}
            loop={false}
          />
        </button>
        <button
          type="button"
          className="web-break-header-btn"
          onClick={() => {}}
        >
          <WebLottiePlayer
            source={storyAssets.lottie.hamburger}
            className="web-break-header-icon"
            autoPlay={false}
            loop={false}
          />
        </button>
      </header>

      <div className="web-break-closing-yeti-area">
        {conversations[0]?.characterImage && (
          <WebLottiePlayer
            source={conversations[0].characterImage}
            className="web-break-closing-yeti"
            autoPlay
            loop
          />
        )}
      </div>

      {current?.content?.trim() && (
        <div className="web-break-closing-bubble">
          <ChatBubble
            key={conversationIndex}
            tailSide="left"
            content={current.content}
            textColor={current.characterFontColor ?? ""}
            audioUri={current.audio ?? ""}
          />
        </div>
      )}

      {conversationIndex === conversations.length - 1 && (
        <div className="web-break-closing-actions">
          <WebShadowButton
            title="Bye bye!"
            onPress={() => {
              onTrackEvent?.(TrackingEvents.navigate_to_journey_back);
              navigate("/web/appJourneyPage");
            }}
          />
        </div>
      )}
    </div>
  );
};

export default WebClosingConvoScreen;
